// extracted by mini-css-extract-plugin
export default {"paragraph":"CoreParagraph-module--paragraph--a89af","isStyleWide":"CoreParagraph-module--isStyleWide--e5a22"};